<template>
  <v-container class="d-flex justify-center ma-0 pa-0" fluid>
    <transition
      name="animate__fadeInOut"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <v-row
        justify="center"
        class="position-absolute fill-width body-top-percent"
        v-if="mobileMenu && !toggleTransition"
      >
        <v-col cols="8" align-self="center" clasd="d-flex justify-center pa-0">
          <!--              user info-->
          <transition
            name="animate__fadeInOut"
            enter-active-class="animate__animated animate__fadeIn"
            leave-active-class="animate__animated animate__fadeOut"
            appear
          >
            <UserCard
              :user-info="getUserInfo"
              :lobby-wallet-balance="lobbyWalletBalance"
            />
          </transition>
        </v-col>

        <v-col cols="10" align-self="center" class="d-flex justify-center">
          <v-row justify="center">
            <v-col
              cols="3"
              align-self="center"
              class="d-flex justify-center pa-1"
            >
              <TwoLayerButton
                :outer-container-class="'outer-layer-button-padding-6px'"
                :inner-container-class="'inner-button-layer py-1 px-0 font-size-xs '"
                :button-text="$translate('all')"
                :primary-color="'blue'"
              />
            </v-col>
            <v-col
              cols="3"
              align-self="center"
              class="d-flex justify-center pa-1"
            >
              <TwoLayerButton
                :outer-container-class="'outer-layer-button-padding-6px'"
                :inner-container-class="'inner-button-layer py-1 px-0 font-size-xs '"
                :button-text="$translate('card')"
                :primary-color="'blue'"
              />
            </v-col>
            <v-col
              cols="3"
              align-self="center"
              class="d-flex justify-center pa-1"
            >
              <TwoLayerButton
                :outer-container-class="'outer-layer-button-padding-6px'"
                :inner-container-class="'inner-button-layer py-1 px-0 font-size-xs '"
                :button-text="$translate('avatar')"
                :primary-color="'blue'"
              />
            </v-col>
            <v-col
              cols="3"
              align-self="center"
              class="d-flex justify-center pa-1"
            >
              <TwoLayerButton
                :outer-container-class="'outer-layer-button-padding-6px'"
                :inner-container-class="'inner-button-layer py-1 px-0 font-size-xs '"
                :button-text="$translate('gem')"
                :primary-color="'blue'"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="11" align-self="center" class="d-flex justify-center">
          <v-container
            fluid
            class="ma-0 pa-2 modal-border shop-scrollable-container"
            :class="{ 'd-flex justify-center align-center': true }"
          >
            <v-row justify="center">
              <v-col
                cols="12"
                align-self="center"
                class="d-flex justify-center"
              >
                <h1 class="success--text">{{ $translate("comingSoon") }}</h1>
              </v-col>
            </v-row>
            <!--            <v-row justify="start">-->
            <!--              <v-col-->
            <!--                cols="4"-->
            <!--                md="3"-->
            <!--                align-self="center"-->
            <!--                class="d-flex justify-center px-1"-->
            <!--                :key="index"-->
            <!--                v-for="(item, index) in gemStrongItems"-->
            <!--              >-->
            <!--                <v-container fluid class="d-flex justify-center">-->
            <!--                  <v-row justify="center">-->
            <!--                    <v-col-->
            <!--                      cols="12"-->
            <!--                      align-self="center"-->
            <!--                      class="d-flex justify-center py-0"-->
            <!--                    >-->
            <!--                      <v-img-->
            <!--                        :src="require('@/assets/shop-gem.png')"-->
            <!--                        max-width="55px"-->
            <!--                      />-->
            <!--                    </v-col>-->
            <!--                    <v-col-->
            <!--                      cols="12"-->
            <!--                      align-self="center"-->
            <!--                      class="d-flex justify-start py-0"-->
            <!--                    >-->
            <!--                      <span-->
            <!--                        class="text-left vListSubtextColor&#45;&#45;text font-size-xs"-->
            <!--                      >-->
            <!--                        Gem Name-->
            <!--                      </span>-->
            <!--                    </v-col>-->
            <!--                    <v-col cols="12" class="d-flex justify-start py-0">-->
            <!--                      <span class="text-left success&#45;&#45;text font-size-small">-->
            <!--                        250$-->
            <!--                      </span>-->
            <!--                    </v-col>-->
            <!--                  </v-row>-->
            <!--                </v-container>-->
            <!--              </v-col>-->
            <!--            </v-row>-->
          </v-container>
        </v-col>

        <v-col cols="11" align-self="center" class="d-flex justify-center">
          <v-row justify="end">
            <v-col
              cols="3"
              align-self="center"
              class="d-flex justify-center py-1"
            >
              <TwoLayerButton
                :outer-container-class="'outer-layer-button-padding-6px'"
                :inner-container-class="'inner-button-layer py-1 px-0 font-size-xs '"
                :button-text="$translate('buy')"
                :primary-color="'blue'"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </transition>
    <DesktopBodyLayout v-if="desktopMenu" :showModalSpot="false">
      <template v-slot:topHeader>
        <v-row justify="start">
          <v-col
            cols="1"
            align-self="start"
            class="d-flex justify-center pa-0 pt-3 mt-2"
          >
            <v-container
              class="d-flex justify-center back-button-container pa-2"
              :class="borderClass"
              @click="backButtonAction()"
              fluid
            >
              <v-btn icon>
                <v-icon large class="success--text font-weight-bold"
                  >mdi-chevron-left</v-icon
                >
              </v-btn>
            </v-container>
          </v-col>
          <v-col cols="5" xl="4" align-self="end" class="pb-0">
            <!--              user info-->
            <UserCard
              :user-info="getUserInfo"
              :lobby-wallet-balance="lobbyWalletBalance"
            />
          </v-col>
          <v-col
            cols="4"
            md="6"
            lg="4"
            align-self="end"
            class="d-flex justify-center"
          >
            <v-row justify="center">
              <v-col cols="3" align-self="center" class="px-1 py-0">
                <TwoLayerButton
                  :outer-container-class="'outer-layer-button-padding-6px'"
                  :inner-container-class="'inner-button-layer py-1 px-0 font-size-xs '"
                  :button-text="$translate('all')"
                  :primary-color="'blue'"
                />
              </v-col>
              <v-col cols="3" align-self="center" class="px-1 py-0">
                <TwoLayerButton
                  :outer-container-class="'outer-layer-button-padding-6px'"
                  :inner-container-class="'inner-button-layer py-1 px-0 font-size-xs '"
                  :button-text="$translate('card')"
                  :primary-color="'blue'"
                />
              </v-col>
              <v-col cols="3" align-self="center" class="px-1 py-0">
                <TwoLayerButton
                  :outer-container-class="'outer-layer-button-padding-6px'"
                  :inner-container-class="'inner-button-layer py-1 px-0 font-size-xs '"
                  :button-text="$translate('avatar')"
                  :primary-color="'blue'"
                />
              </v-col>
              <v-col cols="3" align-self="center" class="px-1 py-0">
                <TwoLayerButton
                  :outer-container-class="'outer-layer-button-padding-6px'"
                  :inner-container-class="'inner-button-layer py-1 px-0 font-size-xs '"
                  :button-text="$translate('gem')"
                  :primary-color="'blue'"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-slot:mainBody>
        <v-row class="mt-10">
          <v-col cols="11" align-self="center" class="d-flex justify-center">
            <v-container
              fluid
              class="modal-border desktop-shop-scrollable-container ma-0 pa-0"
              :class="{ 'd-flex justify-center align-center': true }"
            >
              <v-row justify="center">
                <v-col
                  cols="12"
                  align-self="center"
                  class="d-flex justify-center"
                >
                  <h1 class="success--text">{{ $translate("comingSoon") }}</h1>
                </v-col>
              </v-row>
              <!--              <v-row justify="start" class="my-2">-->
              <!--                <v-col-->
              <!--                  cols="3"-->
              <!--                  align-self="center"-->
              <!--                  class="d-flex justify-center px-1"-->
              <!--                  :key="index"-->
              <!--                  v-for="(item, index) in gemStrongItems"-->
              <!--                >-->
              <!--                  <transition-->
              <!--                    name="animate__fadeInOut"-->
              <!--                    :enter-active-class="-->
              <!--                      'animate__animated animate__fadeIn animate__delay-' +-->
              <!--                      (index + 1) +-->
              <!--                      's-list'-->
              <!--                    "-->
              <!--                    :leave-active-class="-->
              <!--                      'animate__animated animate__fadeOut animate__delay-' +-->
              <!--                      (gemStrongItems.length - index) +-->
              <!--                      's-list'-->
              <!--                    "-->
              <!--                    appear-->
              <!--                  >-->
              <!--                    <ShopItem :key="index" v-if="item.shouldRender" />-->
              <!--                  </transition>-->
              <!--                </v-col>-->
              <!--              </v-row>-->
            </v-container>
          </v-col>
        </v-row>
      </template>
      <template v-slot:desktopFooter>
        <DesktopFooter />
      </template>
    </DesktopBodyLayout>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
// import { analyticMixin } from "../mixins/mixin";
import UserCard from "@/components/UserCard";
import TwoLayerButton from "@/components/Helper/TwoLayerButton";
import DesktopBodyLayout from "@/layouts/desktop/LayoutHelper/DesktopBodyLayout";
import DesktopFooter from "@/layouts/desktop/DesktopFooter";
import animationMixin from "@/mixins/animationMixin";
import ShopItem from "@/components/Shop/ShopItem";
import Services from "@/services/user-services.js";

export default {
  name: "Shop",
  mixins: [animationMixin],
  components: {
    ShopItem,
    DesktopFooter,
    DesktopBodyLayout,
    TwoLayerButton,
    UserCard,
  },
  data() {
    return {
      page: 1,
      gemStrongItems: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      emoji_items: [
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
      ],
      user: {
        username: "",
        userId: "",
        rank: 0,
        avatar: "",
      },
      joinedClubs: [],
      lobbyWalletBalance: 0,
    };
  },
  computed: {
    ...mapGetters([
      "getBackAddress",
      "desktopMenu",
      "mobileMenu",
      "getUserInfo",
      "getLobbyWallet",
      "getRouteData",
    ]),
    borderClass() {
      switch (this.accountClubRole) {
        case "OWNER":
          return "border-blue-2px";
        case "MANAGER":
          return "border-gold-2px";
        case "USER":
          return "border-success-2px";
        default:
          return "border-success-2px";
      }
    },
  },
  methods: {
    ...mapMutations([
      "setUserInfo",
      "setMobileMenu",
      "setDesktopMenu",
      "setLobbyWallet",
      "setWhatPageIsItIn",
      "setShopPageConnectionStatus",
    ]),
    shopItemsRenderCondition(condition) {
      this.gemStrongItems = this.gemStrongItems.map((item) => {
        return {
          ...item, // Copy the existing properties
          shouldRender: condition,
        };
      });
    },
    goToHome() {
      this.$router.push("/home");
    },
    backButtonAction() {
      this.goToHome();
    },
    getWallet() {
      Services.get("wallets/?scope=lobby").then(
        (res) => {
          this.lobbyWalletBalance = res.body.balance;
          this.setLobbyWallet(res.body);
        },
        (error) => {}
      );
    },
    getLobbyData() {
      // const getLobbyWalletApiResult = this.$route.meta.resolvedData;
      if (this.getLobbyWallet === null) {
        this.getWallet();
        this.setShopPageConnectionStatus(true);
      } else {
        this.setShopPageConnectionStatus(true);
        this.lobbyWalletBalance = this.getLobbyWallet.balance;
      }
      // if (getLobbyWalletApiResult.ok) {
      //   this.lobbyWalletBalance = getLobbyWalletApiResult.body.balance;
      //   this.setShopPageConnectionStatus(true);
      // } else this.setShopPageConnectionStatus(false);
    },
  },
  watch: {
    getRouteData() {
      this.shopItemsRenderCondition(false);
    },
  },
  created() {
    this.setWhatPageIsItIn("shop");
    this.getLobbyData();
    this.shopItemsRenderCondition(true);
  },
};
</script>

<style scoped>
.shop-scrollable-container {
  overflow-y: auto;
  overflow-x: hidden;
  /*when coming soon is shown*/
  min-height: 40vh;
  max-height: 40vh;
  background-color: #131313;
  backdrop-filter: blur(5px);
}
.desktop-shop-scrollable-container {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 80vh;
  min-height: 70vh;
  background-color: #131313;
  backdrop-filter: blur(5px);
}
.body-top-percent {
  top: 12%;
}
@media only screen and (max-height: 680px) {
  .shop-scrollable-container {
    min-height: 35vh;
    max-height: 35vh;
  }
}

/*!*iphone se and 7 with safari search bar responsive*!*/
/*@media only screen and (max-height: 660px) and (max-width: 379px) {*/
/*  .shop-scrollable-container {*/
/*    min-height: 20vh;*/
/*    max-height: 20vh;*/
/*  }*/
/*}*/
</style>
